export default "__VITE_ASSET__Czc0Pzk5__"